<template>
  <h3 class="pb5">Repérages des accès interdits triés par nombre (CDX 0014)</h3>
  <CritereRechercheReperages ref="critereRechercheReperages"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import CritereRechercheReperages from "@/components/rapports/Rechercher/CritereRechercheReperages.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "DossiersReperagesAccesInterditsNombre",
  components: {CritereRechercheReperages, ButtonBar},
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Repérage");
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$store.dispatch("narration/rechercherDefaut48HeuresAction")
        .then((res) => {
          this.assignerResultat(res);
        });
  },
  methods: {
    assignerResultat(res) {
      if (res.data.entites !== null)
        this.$refs.critereRechercheReperages.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      var criteresRapportVO = this.$refs.critereRechercheReperages.getCritereRecherche();
      criteresRapportVO.titre = "DossiersReperagesAccesInterditsNombre";
      criteresRapportVO.nomRapport = "NombreReperageAccesInterditsGenerateurRapport_CDX_0014";
      this.$store.dispatch("rapports/obtenirRapportAction",
          criteresRapportVO
      )
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
}
</script>

